'use client'

import { ErrorPdp } from '@/components/ErrorPdp'
import { ItemTemplate } from '@/shared/container'

const ErrorBoundary = ({ error }: { error: Error }) => {
  console.log('Error', error)
  return (
    <ItemTemplate>
      <ErrorPdp />
    </ItemTemplate>
  )
}

export default ErrorBoundary
